module.exports = __webpack_public_path__ + "static/media/LB.addece1f.svg";